// extracted by mini-css-extract-plugin
export default {"shell":"PageShell_shell__qh-VB","dots":"PageShell_dots__K1hMf","content":"PageShell_content__Qchq7","card-in":"PageShell_card-in__q2yZc","narrow":"PageShell_narrow__-GmYp"};